export default __webpack_public_path__ + "static/media/project-wizard-in-app-contents_dark.581f30f5.png";